import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CommonIconButton from '../../components/CommonIconButton';
import Context from '../../provider';
import React, { useContext } from 'react';

export default function ErrorDialog() {
  const { errDialog, dispatch, isMobile } = useContext(Context);
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch({
      type: 'SET_ERROR_DIALOG',
      payload: {
        open: false,
        title: null,
        message: null,
        code: null
      }
    });
  };

  const parseErrorTitle = () => {
    switch (errDialog.title) {
      default:
        return errDialog.title;
    }
  };

  const parseCodeToMessage = () => {
    switch (errDialog.code) {
      // Axios Errors
      case 'econnaborted':
      case 'errNetwork':
      case 'etimedout':
        return t('error.network.content');
      // TODO add more error code to parse message
      default:
        return null;
    }
  };

  const parseErrorMessage = () => {
    const message = parseCodeToMessage();
    if (message) return message;

    return errDialog.message;
  };

  function PaperComponent() {
    return (
      <div className='error-dialog'>
        <div className="text-cont">
          {errDialog?.title && (
            <h1>{parseErrorTitle()}</h1>
          )}
          <p>{parseErrorMessage()}</p>
        </div>
        <CommonIconButton
          text={t('common.next-btn')}
          backgroundColor= {'#004899'}
          btnColor = "#ffffff"
          btnWidth= { isMobile ? '8.75rem' : "15.26rem"}
          padding = { isMobile ? "0.375rem 2.5rem" : "0.625rem 3rem"}
          btnFontSize = { isMobile ? "1.125rem" : "1.9375rem"}
          btnFontWeight = { isMobile ? "400" : "500"}
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
        />
      </div>
    );
  }

  return (
    <Dialog
      onClose={handleClose}
      open={errDialog?.open ?? false}
      PaperComponent={PaperComponent}
    />
  );
}